import PropTypes from "prop-types";
import * as React from "react";
import { importFeeNotice } from "../../../domain/importFees";
import { Typography } from "../../../themeV2";
import css from "./ImportFeeNotices.module.css";

function ImportFeeNotices({ importFees }) {
  return (
    <div role="status" className={css.notices}>
      {importFees.map((fee) => (
        <Typography key={fee.id} variant="body-sm" color="variant" as="p">
          {importFeeNotice(fee)}
        </Typography>
      ))}
    </div>
  );
}

ImportFeeNotices.propTypes = {
  importFees: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      perShipment: PropTypes.number.isRequired,
      destination: PropTypes.string.isRequired,
      reason: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default ImportFeeNotices;
